import Vue from 'vue';

// When the request succeeds
const successLookup = (cbInfo, response) => {
  // console.log('password link check OK response:');
  // console.log(response);
  if (cbInfo && cbInfo.cbSuccess) {
    cbInfo.cbSuccess(response);
  }
};

// When the request fails
const failedLookup = (cbInfo, response) => {
  // console.log('password link check error response:');
  // console.log(response);
  if (cbInfo && cbInfo.cbFail) {
    cbInfo.cbFail(response);
  }
};

export default (userID, token, newPassword, cbInfo) => {
  const axiosOptions = {
    timeout: 10000,
    maxRedirects: 0,
    withCredentials: false,
  };
  const thisurl = `/api/v1/user/${userID}`;
  const payload = {
    user_id: Number(userID),
    password: newPassword,
    token,
  };
  Vue.$http.put(thisurl, payload, axiosOptions)
   .then((response) => {
     successLookup(cbInfo, response);
   })
   .catch((error) => {
     failedLookup(cbInfo, error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/account/changepassword.js